var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBudgetOptions = function SvgBudgetOptions(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.42 384.88C177.42 390.14 184.94 394.96 197.45 398.72H197.46C213.62 403.58 238.12 406.68 265.54 406.68C292.96 406.68 317.46 403.58 333.62 398.72H333.63C346.14 394.96 353.66 390.14 353.66 384.88",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.63 398.72H333.62",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.46 398.72H197.45",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.42 351.13C177.42 357.93 190.01 364.01 209.75 368.01C224.94 371.08 244.37 372.93 265.54 372.93C286.71 372.93 306.14 371.08 321.33 368.01C341.07 364.01 353.66 357.93 353.66 351.13",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.32 334.26H321.31",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.77 334.26H209.76",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.55 304.81C183.39 308.36 177.43 312.7 177.43 317.38C177.43 324.18 190.03 330.26 209.78 334.26C224.96 337.32 244.39 339.17 265.55 339.17C286.71 339.17 306.14 337.32 321.32 334.26C341.07 330.26 353.67 324.18 353.67 317.38C353.67 307.11 324.98 298.51 286.34 296.2H286.31",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.12 266.76H270.11",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.57 266.76H158.56",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.22 283.63C126.22 293.9 154.91 302.5 193.54 304.81C200.2 305.21 207.17 305.42 214.33 305.42C244.05 305.42 270.34 301.78 286.3 296.2H286.32C296.48 292.65 302.45 288.31 302.45 283.63",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.99 237.91C297.14 241.34 302.46 245.46 302.46 249.88C302.46 256.68 289.86 262.75 270.11 266.76C254.93 269.82 235.5 271.67 214.34 271.67C193.18 271.67 173.75 269.82 158.57 266.76C138.82 262.75 126.22 256.68 126.22 249.88C126.22 238.03 164.41 228.4 212 228.09",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M373.78 216.13C373.78 227.97 335.58 237.61 287.99 237.91C287.22 237.92 286.43 237.92 285.65 237.92C254.86 237.92 227.76 234.01 212 228.09C202.85 224.66 197.53 220.55 197.53 216.13",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M329.85 163.52C356.12 167.29 373.78 174.32 373.78 182.38C373.78 189.18 361.19 195.25 341.45 199.25C326.26 202.32 306.83 204.17 285.65 204.17C264.47 204.17 245.05 202.32 229.86 199.25C210.12 195.25 197.53 189.18 197.53 182.38C197.53 176.62 206.57 171.37 221.34 167.48",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M353.66 148.62C353.66 154.38 344.62 159.63 329.85 163.52C313.77 167.77 290.91 170.42 265.54 170.42C249.43 170.42 234.33 169.35 221.34 167.48C195.08 163.71 177.42 156.67 177.42 148.62",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.72 97.8801C340.81 101.87 353.66 108 353.66 114.87C353.66 126.91 314.21 136.66 265.54 136.66C216.87 136.66 177.42 126.9 177.42 114.87C177.42 103.95 209.92 94.9001 252.32 93.3201",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M353.67 114.87V148.62",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.42 114.87V148.62",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M373.78 182.37V216.12",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M197.53 182.37V219.24",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M302.46 249.87V283.63",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.22 249.87V283.63",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M353.67 317.38V384.88",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.42 317.38V384.88",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.99 94.1902H288.65",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBudgetOptions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/budget-options.svg";